import { PropsWithChildren } from 'react';
import { DurationVitalGate, DurationVitalProvider, ReportDurationVital } from './durationVital';

export const PLANS_LIST_FIRST_CONTENT_VITAL = 'plans.list_first_content';

interface PlansListFirstContentProviderProps extends PropsWithChildren {
    context?: Record<string, unknown>;
}

export const PlansListFirstContentProvider = ({
    context,
    children,
}: PlansListFirstContentProviderProps) => (
    <DurationVitalProvider vitalName={PLANS_LIST_FIRST_CONTENT_VITAL} context={context}>
        {children}
    </DurationVitalProvider>
);

export const ReportPlansListFirstContent = ReportDurationVital;

/** Place around PlansList so the vital excludes loading/empty-state gates. */
export const PlansListFirstContentGate = ({ children }: PropsWithChildren) => (
    <DurationVitalGate>{children}</DurationVitalGate>
);
